import { Link } from 'react-router-dom';

export default function CTASection() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20ocean%20gradient%20background%20with%20soft%20golden%20and%20earthy%20tones%2C%20smooth%20flowing%20curves%20suggesting%20waves%2C%20elegant%20minimalist%20texture%2C%20luxurious%20atmosphere%2C%20warm%20amber%20and%20sand%20colors%2C%20abstract%20artistic%20style&width=1800&height=600&seq=cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-primary-800/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好探索鲍鱼的精彩世界了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto">
          数千部高清鲍鱼视频，涵盖养殖、捕捞、加工、烹饪全产业链知识，立即开始您的海洋美食探索之旅
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/pengren"
            onClick={handleClick}
            className="px-6 py-3 bg-background-50 text-primary-700 rounded-full font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-restaurant-line mr-2"></i>
            观看美食教程
          </Link>
          <Link
            to="/about"
            onClick={handleClick}
            className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap border border-background-50/30"
          >
            <i className="ri-team-line mr-2"></i>
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}